/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';
import { Channel } from '../../common/types/types';

interface SetChannelConfidentialMutationProps {
    channel: Channel;
    confidential: boolean;
}

export default class SetChannelConfidentialMutation extends Relay.Mutation<SetChannelConfidentialMutationProps> {
    static propTypes = {
        channel: PropTypes.object.isRequired,
        confidential: PropTypes.bool.isRequired,
    };

    static fragments = {
        channel: () => Relay.QL`
              fragment on Channel {
                    organisation_id,
                    id,
              }
            `,
    };

    getMutation() {
        return Relay.QL`mutation {setChannelConfidential}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on SetChannelConfidentialPayload {
                channel {
                    realId,
                    cachingStatus,
                    metadata,
                    confidential
                },
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'FIELDS_CHANGE',
            fieldIDs: {
                'channel': this.props.channel.id
            }
        }];
    }

    getVariables() {
        return {
            channel_id: this.props.channel.id,
            organisation_id: this.props.channel.organisation_id,
            confidential: this.props.confidential
        };
    }
}
